import { Context } from "../Reducers/Store";
import React, { useCallback, useState, useEffect, useContext } from "react";
import { ToastContainer, Toast } from 'react-bootstrap';
import loading from '../Assets/Images/loading.svg';
function Loading(props) {
    const [state, dispatch] = useContext(Context);
    const { fakeLoad } = props;

    return (<>
        {(state.loading || fakeLoad) &&
            <div style={{
                width: '100%',
                height: '100%',
                position: 'fixed',
                zIndex: 9999,
                top: 0,
                left: 0,
                backgroundColor: 'rgba(205, 205, 205, 0.4)'
            }}>
                <img src={loading} alt='mySvgImage' style={{
                    position: 'absolute',
                    margin: 'auto',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                }} />
            </div>
        }</>
    );
}
export default Loading;